import { render, staticRenderFns } from "./ProfileConfirm.vue?vue&type=template&id=d5aecfe4&"
import script from "./ProfileConfirm.vue?vue&type=script&lang=ts&"
export * from "./ProfileConfirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports